"use client"

import { useCallback, useEffect, useState } from "react"
import styles from "./Search.module.css"
import { useApi } from "../../hooks/useApi"
import UnpaidLicenseTable from "../../components/UnpaidLicenseTable/UnpaidLicenseTable"
import { CircularProgress, Input } from "@mui/material"

export default function Search() {
    const { getFfttPlayers } = useApi()
    const [data, setData] = useState<[] | null>(null)
    const [search, setSearch] = useState<string>("")
    const [isLoading, setIsLoading] = useState<boolean>(true)

    useEffect(() => {
        async function handleFetch() {
            const res = await getFfttPlayers(search)
            if (res) {
                setData(res.response)
            }
            setIsLoading(false)
        }
        handleFetch()
    }, [search])

    const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault()
        setSearch(event.target.value)
    }, [])

    return (<>
        <Input
            onChange={handleChange}
            />
        { isLoading && 
            <div className={styles.circularProgressBox}>
                <CircularProgress />
            </div>
        }
        {data && <UnpaidLicenseTable data={data} />}
    </>)
}